import { Button } from "@/components/ui/button";
import { GraduationCap } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { AUTHENTICATE_SIGNUP, WRITING_WIZARD } from "@/lib/links";
import { useTranslation } from "react-i18next";

export function HeroSection() {
  const { t } = useTranslation(["newLanding"]);
  return (
    <section className="flex flex-col items-center w-full max-w-5xl gap-4 px-4 pt-16 pb-8 mx-auto sm:pt-20 md:pt-24">
      <GraduationCap className="text-primary" size={40} weight="bold" />
      <h1 className="mt-12 text-3xl font-semibold leading-tight tracking-tight text-center whitespace-pre-line sm:text-4xl md:text-5xl">
        {t("hero.title")}
      </h1>
      <p className="text-base leading-relaxed text-center whitespace-pre-line text-muted-foreground sm:text-lg">
        {t("hero.subtitle")}
      </p>
      <div className="flex flex-col w-full gap-3 px-2 mt-2 mb-6 sm:flex-row sm:justify-center sm:items-stretch">
        <Button
          asChild
          className="w-full text-base rounded-full sm:w-auto sm:px-8 text-primary-foreground"
          size="lg"
        >
          <Link to={AUTHENTICATE_SIGNUP}>{t("hero.cta.signup")}</Link>
        </Button>
        <Button
          asChild
          variant="link"
          className="w-full text-base rounded-full sm:w-auto sm:px-8 hover:text-primary"
          size="lg"
        >
          <Link to={WRITING_WIZARD}>{t("hero.cta.demo")}</Link>
        </Button>
      </div>
    </section>
  );
}
